import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { setLocation } from '../../utils/dom';
import { sendAnalyticsEvent } from '../../utils/analytics';

export default class InternationalLink extends PureComponent {
  handleClick = event => {
    event.preventDefault();
    const { href } = event.currentTarget;
    sendAnalyticsEvent(
      'Footer',
      'Click',
      `${this.props.edition_data.basename} to ${this.props.editionBasename}`,
      { hitCallback: () => setLocation(href) }
    );
  }

  render() {
    return (
      <li>
        <a href={this.props.href} onClick={this.handleClick}>{this.props.name}</a>
      </li>
    );
  }
}

InternationalLink.propTypes = {
  editionBasename: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  edition_data: PropTypes.object.isRequired
};
